import { useContext, useEffect, useRef } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import DebugDiv from "./components/DebugDiv";
import CustomerServiceWidget from "./components/CustomerServiceWidget";
import { PersistContext } from "./data/PersistProvider";
import DownloadApp from "./routes/DownloadApp";
import Game from "./routes/Game";
import Index from "./routes/Index";
import About from "./routes/Index/About";
import Contact from "./routes/Index/Contact";
import LanguageChange from "./routes/LanguageChange";
import DepositLog from "./routes/Index/DepositLog";
import Help from "./routes/Index/Help";
import Privacy from "./routes/Index/Privacy";
import Respgame from "./routes/Index/Respgame";
import Termcond from "./routes/Index/Termcond";
import WithdrawControl from "./routes/Index/WithdrawControl";
import WithdrawLog from "./routes/Index/WithdrawLog";
import InviteWheel from "./routes/InviteWheel";
import PiggyBank from "./routes/PiggyBank";
import MakeMoney from "./routes/MakeMoney";
import Login from "./routes/Login";
import SendRegCode from "./routes/Login/SendRegCode";
import LuckyDraw from "./routes/LuckyDraw";
import Setting from "./routes/Setting";
import ChangePwd from "./routes/Setting/ChangePwd";
import Forgot from "./routes/Setting/Forgot";
import SetNewPwd from "./routes/Setting/SetNewPwd";
import Verify from "./routes/Setting/Verify";
import TaskCenter from "./routes/TaskCenter";
import Leaderboard from "./routes/Leaderboard";
import { SendCMD } from "./utils/HTTPRequest";
import { LoadBgSettings } from "./utils/BgSettings";
import HarvestBreadfruit from "./routes/HarvestBreadfruit";
import WreathOfThorns from "./routes/WreathOfThorns";
import { LocalConfig } from "./config";
import OKSpinAnalytics from "./utils/OKSpinAnalytics";
import { SendEvent, SendEventEveryTime } from "@/utils/Analytics";
import PartnerGame from "./routes/PartnerGame";
import GameSearch from "./routes/GameSearch";
import RechargeAppeal from "./routes/RechargeAppeal";
// Translated messages in French with matching IDs to what you declared
const messages = {
  myMessage: "Aujourd'hui, c'est le {ts, date, ::yyyyMMdd}",
};

const locationTitles = {
  "/home": LocalConfig.gameName,
};

const formatLocalDate = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * 映射location对应的title
 * @param {window.location} location
 */
const MapLocationTitles = (location) => {
  let title = LocalConfig.gameName;
  if (typeof locationTitles[location.pathname] !== "undefined") {
    title = locationTitles[location.pathname];
  } else if (location.pathname.startsWith("/c/")) {
    title = LocalConfig.gameName;
  } else {
    title = `${location.pathname.substring(1, 2).toUpperCase()}${location.pathname.substring(2)}`;
    // reaplace "/" to " "
    title = title.replace(/\//g, " ");
    if (title.trim() === "") {
      title = LocalConfig.gameName;
    } else {
      title = `${title} - ${LocalConfig.gameName}`;
    }
  }
  //登录页面，如果reg=1，显示注册
  if (location.pathname === "/login") {
    let query = new URLSearchParams(location.search);
    let reg = query.get("reg");
    if (reg) {
      title = `Register - ${LocalConfig.gameName}`;
    }
  }
  return title;
};
//获取设备码
const useDeviceId = () => {
  let id = localStorage.getItem('deviceId');
  // 如果没有，创建一个新的
  if (!id) {
    id = 'device_' + Math.random().toString(36).substr(2, 9) +
      '_' + new Date().getTime().toString(36);
    localStorage.setItem('deviceId', id);
  }
  return id
}
const App = () => {
  const location = useLocation();
  const { getPersist, setPersist } = useContext(PersistContext);
  const bgLoaderTimer = useRef();
  const bgTaskTimer = useRef();
  const bgTaskExecutor = useRef();
  const bgSettings = getPersist("bgSettings");
  useDeviceId()
  async function loadBgSettings() {
    //定时关闭hallloader，避免因为bgSettings接口的问题导致一直显示loader
    if (bgLoaderTimer.current) {
      clearTimeout(bgLoaderTimer.current);
      bgLoaderTimer.current = null;
    }
    bgLoaderTimer.current = setTimeout(() => {
      closeHallLoader();
    }, 3000);
    await LoadBgSettings(location, getPersist, setPersist);
    closeHallLoader();
  }

  const boomPlayId = getPersist("boomplay_id");
  const mgskyId = getPersist("mgsky_id");
  const okspinId = getPersist("okspin_id");

  //关闭loader
  const closeHallLoader = () => {
    let loader = document.getElementById("hall_loader");
    if (loader) {
      loader.style.display = "none";
      loader.parentNode.removeChild(loader);
    }
  };
  const bgWaittingOrdersRef = useRef(getPersist("bg_waitting_recharge_orders"));

  useEffect(() => {
    bgWaittingOrdersRef.current = getPersist("bg_waitting_recharge_orders");
  }, [getPersist("bg_waitting_recharge_orders")]);

  bgTaskExecutor.current = () => {
    console.log("bgTaskExecutor");
    let nowBgwaittingOrders = bgWaittingOrdersRef.current;
    if (nowBgwaittingOrders && nowBgwaittingOrders.length > 0) {
      let needRemoveOrderIds = [];
      nowBgwaittingOrders.forEach((order) => {
        if (getPersist("user_info") && getPersist("user_info").token) {
          SendCMD("checkRechargeOrder", {
            token: getPersist("user_info").token,
            order_id: order.order_id,
          }).then((res) => {
            if (res.status) {
              if (res.data == "SUCCESS" || res.data == "MANUAL") {
                SendEvent("recharge", {
                  items: [
                    {
                      productId: "1",
                      price: "1",
                      quantity: "#1",
                    },
                  ],
                  transactionId: order.order_id,
                  value: order.value
                });
                needRemoveOrderIds.push(order.order_id);
                if (needRemoveOrderIds.length > 0) {
                  let newBgwaittingOrders = nowBgwaittingOrders.filter((order) => {
                    return !needRemoveOrderIds.includes(order.order_id);
                  });
                  setPersist("bg_waitting_recharge_orders", [...newBgwaittingOrders]);
                  bgWaittingOrdersRef.current = newBgwaittingOrders;
                }
              } else if (res.data == "FAILD") {
                // needRemoveOrderIds.push(order.order_id); //失败状态也先不做处理了，等他超时被自然清除
              } else {
                //待支付状态，不做处理
                console.log("checkRechargeOrder", res.data);
              }
            }
          });
        }
        if (Date.now() - order.created_at > 1000 * 30 * 30) {
          //超过30分钟的，就不管了，直接给他清除
          needRemoveOrderIds.push(order.order_id);
        }
      });
      if (needRemoveOrderIds.length > 0) {
        let newBgwaittingOrders = nowBgwaittingOrders.filter((order) => {
          return !needRemoveOrderIds.includes(order.order_id);
        });
        setPersist("bg_waitting_recharge_orders", [...newBgwaittingOrders]);
        bgWaittingOrdersRef.current = newBgwaittingOrders;
      }
    }
  };


  useEffect(() => {
    if (!bgSettings) {
      loadBgSettings()
        .then(() => { })
        .catch(() => { });
    }
    SendEventEveryTime("daily_total_visit", {
      date: formatLocalDate(new Date()),
    });
    bgTaskExecutor.current();
    if (!bgTaskTimer.current) {
      bgTaskTimer.current = setInterval(() => {
        bgTaskExecutor.current();
      }, 10000);
    }
    return () => {
      if (bgLoaderTimer.current) {
        clearTimeout(bgLoaderTimer.current);
        bgLoaderTimer.current = null;
      }
      if (bgTaskTimer.current) {
        clearInterval(bgTaskTimer.current);
        bgTaskTimer.current = null;
      }
    };
  }, []);
  useEffect(() => {
    let fbPixelId = getPersist("fb_pixel_id");
    console.log("fbPixelId", fbPixelId);
    if (fbPixelId) {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      fbq("init", fbPixelId);
      fbq("track", "PageView");
      let watchTimes = 0;
      let watchFbpID = setInterval(() => {
        if (++watchTimes > 100) {
          clearInterval(watchFbpID);
        }
        let fbpID = "";
        var value = "; " + document.cookie;
        var parts = value.split("; _fbp=");
        if (parts.length == 2) {
          fbpID = parts.pop().split(";").shift();
          if (fbpID) {
            localStorage.setItem("attribution", "fb");
            localStorage.setItem("attribution_id", fbpID);
            localStorage.setItem("ad_source", fbPixelId);
            clearInterval(watchFbpID);
          }
        } else {
          console.error("cookie", document.cookie);
        }
      }, 300);
    }
  }, [getPersist("fb_pixel_id")]);

  useEffect(() => {
    console.log("boomplay_id", boomPlayId);
    if (boomPlayId) {
      (function (w, d, t, s) {
        if (w.bp_dsp) return;
        w.bp_dsp = function () {
          bp_dsp.token ? bp_dsp.token.apply(bp_dsp, arguments) : bp_dsp.queue.push(arguments);
        };
        bp_dsp.version = "0.0.0";
        bp_dsp.queue = [];
        var dom = d.createElement(t);
        dom.async = true;
        dom.src = s;
        var p = d.getElementsByTagName(t)[0];
        p.parentNode.insertBefore(dom, p);
      })(window, document, "script", "https://ads.najocp.com/boomplay_dsp.min.js");
      bp_dsp("init", boomPlayId);
    }
  }, [boomPlayId]);

  useEffect(() => {
    console.log("mgskyId", mgskyId);
    if (mgskyId) {
      const script = document.createElement("script");
      script.src = `https://s.mgskyads.com/js/tag.js?aa=${mgskyId}`;
      script.async = true; // 异步加载
      // 将script标签添加到body或head中
      document.body.appendChild(script);
      // 清理函数，组件卸载时移除script标签
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [mgskyId]);

  useEffect(() => {
    console.log("okspinId", okspinId);
    if (okspinId) {
      const script = document.createElement("script");
      script.src = `https://s.oksp.in/js/tag.js?aa=${okspinId}`;
      script.async = true; // 异步加载
      script.onload = () => {
        OKSpinAnalytics.GetInstance(okSpinUserInfo);
      };
      // 将script标签添加到body或head中
      document.head.appendChild(script);
      //初始化okspin的事件发送器
      let okSpinUserInfo = {
        visitorId: window.guestId ? window.guestId() : "",
        customerId: "",
      };
      if (getPersist("user_info")) {
        okSpinUserInfo.customerId = getPersist("user_info").rid;
      }
      // 清理函数，组件卸载时移除script标签
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [okspinId]);

  // //adjust
  // useEffect(() => {
  //   // 动态加载 Adjust Web SDK
  //   const script = document.createElement("script");
  //   script.src = "https://cdn.adjust.com/adjust-web-sdk.min.js";
  //   script.async = true;
  //   document.head.appendChild(script);

  //   script.onload = () => {
  //     // SDK 加载完成后初始化 Adjust
  //     if (window.Adjust) {
  //       window.Adjust.initSdk({
  //         appToken: "fsyxeqvxyayo", // 替换为你的 Adjust App Token
  //         environment: "sandbox",     // 测试环境用 "sandbox"，生产环境用 "production"
  //         logLevel: "verbose",       // 可选：调试时开启详细日志
  //         onAttributionChanged: function (attribution) {
  //           console.log("Adjust Attribution:", attribution);
  //           // 处理归因数据（如发送到服务器或存储到本地）
  //           localStorage.setItem("adjust_attribution", JSON.stringify(attribution));
  //         }
  //       });
  //       // 可选：发送自定义事件（如用户注册、购买等）
  //       window.Adjust.trackEvent({
  //         eventToken: "ot0n5x" // 在 Adjust 后台创建的事件 Token
  //       });
  //     }
  //   };

  //   // return () => {
  //   //   // 组件卸载时移除 script 标签（可选）
  //   //   document.head.removeChild(script);
  //   // };
  // }, []);

  useEffect(() => {
    console.log("location", location);
    let title = MapLocationTitles(location);
    if (document.title != title) {
      document.title = title;
    }
  }, [location]);



  return (
    <div id="app">
      <Switch>
        <Route exact path="/home">
          <Index />
        </Route>
        <Route exact path="/px">
          <Index />
        </Route>
        <Route exact path="/c">
          <Index />
        </Route>
        <Route exact path="/deposit">
          <Index />
        </Route>
        <Route exact path="/promotion">
          <Index />
        </Route>
        <Route exact path="/withdraw">
          <Index />
        </Route>
        <Route exact path="/profile">
          <Index />
        </Route>
        <Route exact path="/invite">
          <Index />
        </Route>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/sendRegCode">
          <SendRegCode />
        </Route>
        <Route exact path="/game">
          <Game />
        </Route>
        <Route exact path="/help">
          <Help />
        </Route>
        <Route exact path="/about">
          <About />
        </Route>
        <Route exact path="/contact">
          <Contact />
        </Route>
        <Route exact path="/languageChange">
          <LanguageChange />
        </Route>
        <Route exact path="/Termcond">
          <Termcond />
        </Route>
        <Route exact path="/Privacy">
          <Privacy />
        </Route>
        <Route exact path="/Respgame">
          <Respgame />
        </Route>
        <Route exact path="/depositLog">
          <DepositLog />
        </Route>
        <Route exact path="/withdrawLog">
          <WithdrawLog />
        </Route>
        <Route exact path="/setting">
          <Setting />
        </Route>
        <Route exact path="/changePwd">
          <ChangePwd />
        </Route>
        <Route exact path="/forgot">
          <Forgot />
        </Route>
        <Route exact path="/verify">
          <Verify />
        </Route>
        <Route exact path="/setNewPwd">
          <SetNewPwd />
        </Route>
        <Route exact path="/withdrawControl">
          <WithdrawControl />
        </Route>
        <Route exact path="/downloadApp">
          <DownloadApp />
        </Route>
        <Route exact path="/luckyDraw">
          <LuckyDraw />
        </Route>
        <Route exact path="/taskCenter">
          <TaskCenter />
        </Route>
        <Route exact path="/Leaderboard">
          <Leaderboard />
        </Route>
        <Route exact path="/InviteWheel">
          <InviteWheel />
        </Route>
        <Route exact path="/PiggyBank">
          <PiggyBank />
        </Route>
        <Route exact path="/MakeMoney">
          <MakeMoney />
        </Route>
        <Route exact path="/harvest">
          <HarvestBreadfruit />
        </Route>
        <Route exact path="/wreath">
          <WreathOfThorns />
        </Route>
        <Route exact path="/PartnerGame">
          <PartnerGame />
        </Route>
        <Route exact path="/GameSearch">
          <GameSearch />
        </Route>
        <Route exact path="/RechargeAppeal">
          <RechargeAppeal />
        </Route>
        <Route path="/">
          <Index />
        </Route>
      </Switch>
      <DebugDiv />
      <CustomerServiceWidget />
    </div>
  );
};

export default App;
